import { render, staticRenderFns } from "./SuspiciousActivityReview.vue?vue&type=template&id=3f77ceb4&"
import script from "./SuspiciousActivityReview.vue?vue&type=script&lang=js&"
export * from "./SuspiciousActivityReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports